import { createFileRoute, redirect } from "@tanstack/react-router";

/* An old link to the Agent opens Menus with the agent beside it, conversation and all. */
export const Route = createFileRoute("/_authenticated/agents/menus/")({
  validateSearch: (search: Record<string, unknown>): { c?: string } =>
    typeof search.c === "string" && search.c ? { c: search.c } : {},
  beforeLoad: ({ search }) => {
    throw redirect({ to: "/menus/agent", search, replace: true });
  },
});
